import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config/app-config.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationCheckGuard {
  constructor(
    private readonly configurationService: AppConfigService,
    private readonly router: Router
  ) {}

  public canActivate(): Promise<boolean> | boolean {
    if (!this.configurationService.canAccessLimitSets) {
      this.router.navigate(['/access-denied']);
      return false;
    }
    return true;
  }
}
